import { Checkbox, ListItemButton, ListItemText } from '@mui/material';
import { NotificationSetting } from 'features/notifications/notifications.types';
import { NotificationTypes } from 'features/notifications/notifications.constants';
import { REGION_LIST_ITEM_HEIGHT } from './constants';

type RegionListItemProps = {
  onChange: (newRegionSetting: NotificationSetting) => void;
  regionSetting: NotificationSetting;
};

export const RegionListItem = (props: RegionListItemProps): JSX.Element => {
  const { onChange, regionSetting } = props;
  const { displayName } = regionSetting.region;
  const { setting } = regionSetting;

  const handleChange = (): void => {
    onChange(regionSetting);
  };

  const isChecked = setting !== NotificationTypes.OFF.key;

  return (
    <ListItemButton
      onClick={handleChange}
      aria-labelledby={displayName}
      sx={{
        height: REGION_LIST_ITEM_HEIGHT,
        paddingLeft: 3,
        gap: 2,
        // Tells the browser to skip layout/paint for off-screen rows; the
        // intrinsic size prevents scroll-position drift while items are skipped.
        contentVisibility: 'auto',
        containIntrinsicSize: `0 ${REGION_LIST_ITEM_HEIGHT}px`,
      }}
    >
      <Checkbox
        checked={isChecked}
        tabIndex={-1}
        sx={{
          padding: 0,
          color: 'primary.main',
        }}
      />
      <ListItemText
        primary={displayName}
        id={displayName}
        sx={{ minWidth: 0 }}
        slotProps={{
          primary: {
            noWrap: true,
          },
        }}
      />
    </ListItemButton>
  );
};
